<template>
  <Card>
    <CardHeading heading="Support" :showCapacity="false" :showButton="false" />
    <Input
      id="btnLabel"
      @input-change="handleChange"
      name="developBy"
      key="developBy"
      label="Developed by"
      class="mb-4"
      styles="font-weight: 400"
      placeholder="Developer’s name"
      :value="support.developBy"
    />
    <Input
      id="btnUrl"
      @input-change="handleChange"
      name="email"
      label="Support email"
      class="mb-2"
      styles="font-weight: 400"
      key="email"
      placeholder="support@example.com"
      :value="support.email"
    />
  </Card>
</template>

<script>
import Card from '@/components/DesignSystem/Card';
import CardHeading from '@/components/DesignSystem/CardHeading';
import Input from '@/components/DesignSystem/Input';

export default {
  name: 'SupportContentSection',
  props: {
    namespace: String,
  },
  components: {
    Input,
    CardHeading,
    Card,
  },
  computed: {
    support() {
      return this.$store.getters[`${this.namespace}/support`];
    },
  },
  methods: {
    handleChange(payload) {
      this.$store.dispatch(`${this.namespace}/updateSupport`, payload);
      this.$store.dispatch(`${this.namespace}/addDirtyTab`, {
        endpoint: 'support/',
        storeKey: 'support',
      });
      this.$forceUpdate();
    },
  },
};
</script>
